export default __webpack_public_path__ + "ddcd7b22af44079c7c0a7cf17256e96a.png";